import * as $ from 'jquery';
import {safeLocalStorage} from '../utils/safeLocalStorage.js';
import * as utils from '../utils.js';
import * as bi from '../tracking/bi.js';
import '../utils/share.js';
import { makeCommentCreateEvent } from '../utils/comment.js';
import { post, del } from '../utils/ajax.js';
import { productWhoLikes, productReport, fiscalDocument } from '../product_sheet';
import { onLoad } from '../utils/onLoad.js';
import { showModalOnLoad } from '../utils/modals';
import appPdf from '../utils/app_pdf';
import setImageZoomCarousels from './imageZoomCarousel';
import { setPublishedProductsIndicator } from '../components/progress-bar.js';
import { money } from '../money.js';
// Data models tracking (BI & Zendesk)
import { UserViewingLikesBIModel } from '../BI/models';
import {OfferResponseEvent} from '../Shared/events';

// Domain Events
import {offerResponseEventTrigger} from '../events/triggers/offer-response.js';
import {setMakeOffer} from '../product_sheet/offers.js';
import {setDrawers} from '../utils/drawers.js';
import {setCarouselControls} from '../components/carousel.js';
import {setCollapse} from '../components/collapse.js';
import {delegateListener} from '../utils/delegate-listener.js';
import {appSetString} from '../app-set-string.js';

const getProductId = () => parseInt(document.getElementById('product-sheet').dataset.idProduct);

if (utils.isLogged()) {

    if (utils.canCallApp('editProductPrice')) {
        //Editar precio del producto
        document.querySelectorAll('.js-edit-product-price-link').forEach(btn => {
            btn.addEventListener('click', e => {
                e.preventDefault();
                Trendier.editProductPrice(getProductId());
            });
        });
    }

    // Send BI event product view
    bi.trackProductView();

    if (utils.isApp()) {
        $(document).on('focus click', '#product-sheet .js-comment-product input', function () {
            this.scrollIntoView();
        });

        appPdf();
    }

    // Comentar
    $(document).on('submit', '.js-comment-product', async function (e) {
        e.preventDefault();
        if (utils.redirectAnonymous()) {
            return;
        }

        const $input = $(this).find('[name="txtcomment"]'),
            $commentButtons = document.querySelectorAll('.js-comment-product button');


        if ($input.val().length < 2) {
            $commentButtons.forEach((btn) => utils.btnLoading($(btn), false));
            return;
        }

        $commentButtons.forEach((el) => {
            el.disabled = 'disabled';
        }); 
        const formData = new FormData(this);

        post($(this).attr('action'), formData, true, true).then((response) => {
            document.dispatchEvent(new CustomEvent('commentPost', { detail: { comment: response, element: this } }));
            $commentButtons.forEach((el) => {
                el.removeAttribute('disabled');
                utils.btnLoading($(el), false);
            });
            if (typeof response === 'undefined') {
                utils.defaultAlertModal('Ha ocurrido un error al intentar realizar el comentario.');
            }
            if (response.success) {
                let $newComment = $('#new-comment-template').html().trim();
                $newComment = $($newComment);
                $newComment.find('.js-comment-text').html(utils.boldCitations(response.commentText));
                $newComment.find('.js-delete-comment').val(response.commentId);
                $newComment.find('[value="#reply-to-"]').val("#reply-to-" + response.commentId);
                $newComment.find('#reply-to-').attr("id", "reply-to-" + response.commentId);
                $newComment.attr("id", "comment-" + response.commentId);
                $newComment.find('input[name="parent"]').val(response.commentId);
                $newComment.find('.js-report-comment').val(response.commentId);
                if (['pending', 'pending_system'].includes(response.commentStatus)) {
                    $newComment.find('.js-pending-review').removeClass('d-none');
                } else {
                    $newComment.find('.js-pending-review').remove();
                }

                document.dispatchEvent(makeCommentCreateEvent(this));
                this.dataset.productTotalComments++;
                this.dataset.timeSinceLastComment = 0;

                if ($(this).find('[name="parent"]').length) {
                    $newComment.find('.js-open-reply, .text-grey-400, form').remove();
                    let reply = $(this).closest('.comment-reply-input').addClass('d-none');
                    $newComment.insertBefore(reply);
                } else {
                    $('.comment-box-wrapper').append($newComment).scrollTop(1E10);
                }
                $(this).find(':focus').blur();
                if ($input.attr('type') != 'submit') {
                    $input.val('');
                }
            } else if (response.message) {
                utils.defaultAlertModal(response.message, true);
            }

        }).catch((e) => {
            $commentButtons.forEach((el) => {
                el.removeAttribute('disabled');
                utils.btnLoading($(el), false);
            });
            utils.defaultAlertModal('Ha ocurrido un error al intentar realizar el comentario.');
        });

    });


    let replyLimitTimeout;
    const citationsRegex = new RegExp(utils.config.citations_regex, 'g');
    $(document).on('keyup', '.js-comment-product textarea', e => {

        clearTimeout(replyLimitTimeout);
        replyLimitTimeout = window.setTimeout(() => e.target.closest('form')
            .querySelector('.js-reply-limit')
            .classList.toggle('d-none',
                (e.target.value.match(citationsRegex) || []).length <= utils.config.max_citations_per_comment
            )
            , 200
        );
    });

    //
    // Reportar comment
    $(document).on('click', '.js-report-comment-button', function (e) {
        const commentId = this.value;
        e.preventDefault();
        utils.defaultConfirmModal(
            document.getElementById('report-comment-confirm').innerHTML,
            () => {
                post(`/api/v5/products/${getProductId()}/comments/${commentId}`, {}, false, true)
                    .then(response => $(this).parent().html('Reportado'));
            }
        );
        $('#default-modal .js-dialog-success').text('Reportar');
    });

    onLoad(() => {
        const url = document.URL,
            anchor = url.split('#'),
            textArea = document.getElementById('newCommentForm');
        if (null != textArea && null != anchor[1] && anchor[1] == 'newComment') {
            textArea.scrollIntoView({ block: 'end', behavior: 'smooth' });
            textArea.focus();
        }
        // Reportar product
        productReport();

        // Captura de documento fiscal para pedidos de USA
        fiscalDocument();

        // Unique product alert
        let product_sheet_visits = safeLocalStorage.getItem('product_sheet_visits') || 1;
        if (product_sheet_visits <= 2) {
            safeLocalStorage.setItem('product_sheet_visits', product_sheet_visits + 1);
            const alert = $('.unique-product-alert');
            alert.collapse('show');
            window.setTimeout(() => alert.collapse('hide'), 4000);
        }

        // Stepper hide alert on collapse
        const stepperElement = document.querySelector('.stepper-collapse');
        const stepperOutsideAlert = document.querySelector('.stepper + .nds-alert');

        stepperOutsideAlert && stepperElement?.addEventListener('click', e => {
            e.preventDefault();
            if (stepperElement.classList.contains('collapsed')) {
                stepperOutsideAlert.classList.replace('d-flex', 'd-none');
            } else {
                stepperOutsideAlert.classList.replace('d-none', 'd-flex');
            }
        });

        setPublishedProductsIndicator('.js-published-products-indicator');

        // BEGIN --> Send BI user_viewing_likes event tracking on click "Me gusta" link
        (() => {
            const elementUserViewingLikes = document.querySelector('.js-bi-user-viewing-likes');

            const handleUserViewingLikes = () => {
                const userViewingLikesBIModel = new UserViewingLikesBIModel(utils.config.user.id, utils.config.product_id, elementUserViewingLikes.dataset.biIsOwner);
                bi.track(userViewingLikesBIModel);
            }

            if (elementUserViewingLikes) {
                elementUserViewingLikes.addEventListener('click', handleUserViewingLikes);
            }

        })();
        // END --> Send BI user_viewing_likes event tracking on click "Me gusta" link

    });

    showModalOnLoad();

    let toggleReply = function (commentId) {
        if (commentId) {
            let reply = $('#comment-' + commentId).find('.comment-reply-input'); //'input[name="txtcomment"]'
            if (!reply.length) { //si ya era una respuesta buscar el papi
                reply = $('#comment-' + commentId).parents('.js-comment').find('.comment-reply-input');
            }
            if (reply.length) {
                let input = reply.find('[name="txtcomment"]'),
                    text = input.val();
                reply.toggleClass('d-none');
                if (!reply.hasClass('d-none')) {
                    input.val('').val(text).focus(); //Truco para que el cursor se quede al final
                }
            }
        }
    };

    // Abrir responder comment
    $(document).on('click', '.js-open-reply', function () {
        toggleReply($(this).val().match(/\d+/g));
    });

    //
    // Borrar comment
    $(document).on('click', '.js-delete-comment', function (e) {
        const commentId = this.value;
        e.preventDefault();
        utils.defaultConfirmModal(
            document.getElementById('delete-comment-confirm').innerHTML,
            () => {
                del(`/api/v5/products/${getProductId()}/comments/${commentId}`, {}, false)
                    .then(response => $(this).closest('.js-comment').remove());
            }
        );
        $('#default-modal .js-dialog-success').text('Eliminar');
    });

    //
    // Scroll comentarios en el bottom
    if ($('.comment-box-wrapper').length) {
        $('.comment-box-wrapper')[0].scrollTop = $('.comment-box-wrapper')[0].scrollHeight;
    }

    // Scroll comment id  by noti url
    if (window.location.hash) {
        setTimeout(() => {
            let commentId = window.location.hash.match(/\d+/g);
            if (commentId) {
                toggleReply(commentId);
            } else if (window.location.hash === '#product_comments') {
                $('.input-main-comment:visible').focus();
            }
        }, 100);
    }

    //
    // Focus del label al textarea de comentar
    document.querySelectorAll('.js-txtcomment-label').forEach((label) => {
        label.addEventListener('click', () => {
            label.closest('form').querySelector('[name="txtcomment"]').focus()
        });
    });

    const DELAY_TOOLTIP = 5000;

    $(document).on('show.bs.modal', '#modal-who-like-product', async () => {
        productWhoLikes();
    });

    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.has('showLikes') && utils.isLogged()) {
        currentUrl.searchParams.delete('showLikes');
        history.pushState('', document.title, currentUrl.href); //remove showLikes param to not show it again on reload
        $('#modal-who-like-product').modal('show');
    }

    const tooltipLikeConfig = {
        animation: true,
        customClass: 'show-likes-tooltip',
        placement: 'bottom'
    }

    const selectorBtnLikes = '.js-show-likes-btn';
    const btnLikes = $(selectorBtnLikes);
    const btnLikesNodeList = document.querySelector(selectorBtnLikes);

    const inViewObserverLikes = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !safeLocalStorage.getItem('show-likes-tooltip-seen')) {
                btnLikes
                    .tooltip(tooltipLikeConfig)
                    .tooltip('show');
                safeLocalStorage.setItem('show-likes-tooltip-seen', "1");
                document.addEventListener('click', function hideTooltipLike() {
                    btnLikes.tooltip('hide')
                    this.removeEventListener('click', hideTooltipLike);
                });
                const tooltip = document.querySelector('.show-likes-tooltip');
                tooltip?.addEventListener('click', e => {
                    e.preventDefault();
                    $('#modal-who-like-product').modal('show');
                    disposeShowLikesTooltip(btnLikesNodeList);
                });
                btnLikesNodeList?.addEventListener('click', () => {
                    disposeShowLikesTooltip(btnLikesNodeList);
                });
            }
        })
    }, { threshold: 1 })

    if (btnLikes && btnLikesNodeList && !safeLocalStorage.getItem('show-likes-tooltip-seen')) {
        inViewObserverLikes.observe(btnLikesNodeList);
        $(document).on('shown.bs.tooltip', function (e) {
            if (e.target.classList.contains('js-show-likes-btn')) {
                setTimeout(function () {
                    $(e.target).tooltip('dispose');
                }, DELAY_TOOLTIP);
            }
        });
    }

    const disposeShowLikesTooltip = (btn) => {
        $(btn).tooltip('dispose');
        safeLocalStorage.setItem('show-likes-tooltip-seen', "1");
    };

    setMakeOffer();

} else {

    document.addEventListener('submit', (e) => {
        if (e.target.classList.contains('js-comment-product')) {
            const commentButtons = document.querySelectorAll('.btn-loading');
            e.preventDefault();

            commentButtons.forEach((button) => {
                utils.btnLoading(button, false);
            });

            utils.redirectAnonymous();
        }
    });

    document.addEventListener('click', (e) => {
        const elementClicked = e.target;
        if (elementClicked.classList.contains('js-open-reply') || !!elementClicked.closest('.js-report-product-btn')) {
            e.preventDefault();
            utils.redirectAnonymous();
        }
    });
}

const setOfferAnswers = () => {
    const offerAnswerBtnSelector = '.js-offer-answer-btn';
    delegateListener('click', offerAnswerBtnSelector, e => {
        const btn = e.target.closest(offerAnswerBtnSelector);
        let data = {};
        data.accepted = btn.dataset.action === 'accept';
        const message = document.querySelector('.js-seller-offer-message')?.value;
        if (typeof message !== 'undefined' && message !== '') {
            data.message = message;
        }

        const productId = utils.config.product_id;
        const offerId = btn.dataset.offerId;

        post(`/api/v5/products/${productId}/offers/${offerId}`, data, false, true).then(response => {
            if (data.accepted && response === '') {
                alert("Oops! Hubo un error al responder oferta, inténtalo más tarde");
                return;
            }

            // Datos para el evento
            const userId = utils.config.user.id;
            const answer = btn.dataset.action;
            const message = data.message || '';
            const buyerId = btn.dataset.buyerId;

            const offerResponseEvent = new OfferResponseEvent(userId, productId, offerId, answer, message, buyerId);
            document.dispatchEvent(offerResponseEvent);
            offerResponseEventTrigger();

            location.reload();
        });
    });
};

const setAppShareString = () => {
    if (utils.config.is_owner) {
        appSetString(`¡Te va a gustar mi artículo en ${utils.config.brand_name}! ${utils.config.productTitle} por solo ${money(utils.config.productPrice)}.`);
    } else {
        appSetString(`¿Qué te parece este artículo que vi en ${utils.config.brand_name}? ${utils.config.productTitle} por solo ${money(utils.config.productPrice)}`);
    }
};

onLoad(() => {
    //
    // Ir a comentar
    $(document).on('click', '.to-input-main-comment', function (e) {
        e.preventDefault();
        $('.input-main-comment:visible').focus();
        $('.input-main-comment:visible').click();
    });
    setImageZoomCarousels();
    setDrawers();
    setCarouselControls(document.getElementById('carousel-ficha'));
    setCollapse();
    setOfferAnswers();
    setAppShareString();
});
